import {
    Component,
    Input,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { cloneDeep } from "lodash";
import { take } from "rxjs/operators";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { ActionButtonComponent } from "../action-button/action-button.component";
import { ButtonComponent } from "../button/button.component";
import { HeaderComponent } from "../header/header.component";
import { InputComponent } from "../input/input.component";
import { ModalSettings } from "../modal/modal-models";
import { INamedSearchFilter } from "./model/INamedSearchFilter";
import { SaveSearchFilterService } from "./service/save-search-filter.service";

@Component({
    selector: "rask-save-search-filter",
    templateUrl: "./save-search-filter.component.html",
    styleUrls: ["./save-search-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ActionButtonComponent,
        NgbTooltip,
        InputComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class SaveSearchFilterComponent implements OnInit {
    errors: string[];
    filter = {
        namn: "",
        filter: undefined
    };
    @Input() filterData: any;
    @Input() maxSavedFilters: number;
    @ViewChild("tooltip") tooltip: NgbTooltip;
    @Input() webbinstallningarKey: string;

    private readonly modalService = inject(RaskModalService);
    private readonly searchService = inject(SaveSearchFilterService);

    abort() {
        this.close();
    }

    close() {
        this.reset();
        this.tooltip.close();
    }

    ngOnInit(): void {
        this.searchService.getSavedFiltersInstallningar(this.webbinstallningarKey);
        this.reset();
    }

    onClose() {
        this.reset();
    }

    trySave() {
        this.filter.filter = cloneDeep(this.filterData);
        if (!this.filter.namn) {
            this.errors = ["Ange namn"];
            return;
        }
        if (!this.searchService.nameIsUnique(this.filter)) {
            const ejUniktNamn = this.filter.namn;
            this.modalService.confirm(new ModalSettings("Det finns redan en sökning med detta namn", `Vill du skriva över "${ejUniktNamn}"?`))
                .pipe(take(1))
                .subscribe((ok: string) => {
                    if (ok === ConfirmDialogResponse.cancel) {
                        return;
                    }
                    this.searchService.updateSearchFilterByNamn(this.filter, this.webbinstallningarKey);
                    this.close();
                });
        } else {
            if (this.searchService.saveLimitReached(this.maxSavedFilters)) {
                this.errors = ["Det går ej att spara fler sökningar. Du kan ersätta eller ta bort en sökning"];
                return;
            }
            this.searchService.saveSearchFilter(this.filter, this.webbinstallningarKey);
            this.close();
        }
    }

    private reset() {
        this.filter = { namn: "" } as INamedSearchFilter;
        this.errors = [];
    }
}
